// components/Reusablesteps/onboarding/VerifiedScreen.jsx
// Green-tick identity-confirmed screen shown after OTP for both flows.

import React from "react";
import styles from "./Onboarding.module.css";
import { PrimaryBtn, ArrowRight } from "./onboardingTokens";

/**
 * VerifiedScreen
 *
 * @param {string}   name        - patient name (optional; shown in greeting)
 * @param {string}   ctaLabel    - button text  (default "Go to Symptoms")
 * @param {function} onContinue  - () => void
 */
const VerifiedScreen = ({
  name       = "",
  ctaLabel   = "Go to Symptoms",
  onContinue,
}) => (
  <div className={styles.wrap}>
    <div className={styles.centre}>

      {/* Animated tick bubble */}
      <div className={styles.verifiedBubble}>✅</div>

      {/* Copy */}
      <div style={{ textAlign: "center" }}>
        <h2 className={styles.question}>
          Welcome{name ? `, ${name}` : ""}!
        </h2>
        <p className={styles.desc}>
          Your identity has been verified successfully.
        </p>
      </div>

      {/* CTA */}
      <div style={{ width: "100%", maxWidth: 320 }}>
        <PrimaryBtn
          label={ctaLabel}
          onClick={onContinue}
          icon={<ArrowRight />}
        />
      </div>

    </div>
  </div>
);

export default VerifiedScreen;
